<template>
  <div class="stack">
    <div class="card">
      <router-link class="banner-link" :to="{ name:'HowToPage' }">
        <img src="/images/howto.jpg" alt="boatnaviの使い方" />
      </router-link>
    </div>

    <div id="right_access_ranking">
      <div id="boat-ranking"></div>
    
      
      <!-- ここをスマホで非表示（レンダリングしない）にする -->
      <Adsense
        v-if="!isMobile"
        class="adsbygoogle"
        data-ad-client="ca-pub-3076785709839281"
        data-ad-slot="1168603868"
        data-ad-format="auto"
        :data-full-width-responsive="true"
        :style-obj="{ display:'inline-block', width:'300px', height:'600px' }"
        :collapseIfNoFill="true"
        :collapseAfter="1500"
      />
    </div>
  </div>
</template>

<script>
import Adsense from '@/components/Adsense.vue'

export default {
  name: 'AsideCommon',
  components: { Adsense },
  data() {
    return {
      isMobile: false,
      mq: null  // ← `_mq` を `mq` に変更
    }
  },
  mounted() {
    // 1023px以下をスマホ扱い
    this.mq = window.matchMedia('(max-width: 1023px)')
    const update = () => { this.isMobile = this.mq.matches }
    update()
    if (this.mq.addEventListener) this.mq.addEventListener('change', update)
    else if (this.mq.addListener) this.mq.addListener(update)
  },
  beforeDestroy() {
    // クリーンアップ
    const update = () => {}
    if (this.mq) {
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', update)
      else if (this.mq.removeListener) this.mq.removeListener(update)
    }
  }
}
</script>

<style scoped>
/* 既存のCSSそのまま */
.stack > * + * { margin-top: 16px; }
a.banner-link{ display:block; background:#FFF; }
a.banner-link img{ display:block; opacity:1; }
a.banner-link:hover img, a.banner-link:focus img{ opacity:.7; }
.banner-link:active img{ opacity:.9; }
.stack .card{ border:0; }
.stack .card .banner-link{ margin:0 auto; }
@media (max-width:1023px){ .stack{ padding:0 10px; } }
</style>